import { IconPublic } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

import { StyledTextLink } from './StyledTextLink';

const PickerLink = styled(StyledTextLink)`
  display: flex;
  align-items: center;
`;

export const NavBarCountryRegionPicker = () => {
  return (
    <PickerLink href="https://www.spotify.com/uk/select-your-country-region/">
      <IconPublic iconSize={16} />
    </PickerLink>
  );
};
